module.exports = __webpack_public_path__ + "static/media/indentplanner3.5ad60851.png";